enum AlertPriceType {

    Hourly = 1,
    Daily = 2,
    FromNow = 3
}
export default AlertPriceType;
